import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return undefined;
  }

  if (profile.connectedNotification) {
    return profile.connectedNotification;
  } else {
    return undefined;
  }
};
//VERIFY IF THE JWT IS SET
const getMyConnectedMembersCount = createSelector(getData, count => count);
export default getMyConnectedMembersCount;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyConnectedMembersCount.js